export default "__VITE_ASSET__BYKeWHcf__"